
  import RichText from '@/components/elements/RichText';
  import ShareIcons from '@/components/ShareIcons';
  import LazyHydrate from 'vue-lazy-hydration';
  import StarRatingActionButton from '@/components/StarRatingActionButton';
  import JobDetailsHeader from '@/components/JobDetailsHeader';
  import OrganizationLogo from '@/components/elements/OrganizationLogo.vue';
  export default {
    components: {
      OrganizationLogo,
      JobDetailsHeader,
      JobDetailsLocationCard: () =>
        import('@/components/JobDetailsLocationCard'),
      AvailabilitySlotList: () =>
        import('@/components/elements/AvailabilitySlotList'),
      RichText,
      ShareIcons,
      LazyHydrate,
      StarRatingActionButton,
    },
    filters: {
      empty_default: function (value) {
        if (!value || value === '') {
          return 'k.A.';
        } else {
          return value;
        }
      },
    },
    props: {
      job: {
        type: Object,
        required: true,
      },
      application: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      favorite: {
        type: Object,
        required: false,
        default: () => ({}),
      },
    },
    data() {
      return {
        organization: {},
      };
    },
    created() {
      this.organization = this.job.organization;
    },
    methods: {
      addStar() {
        this.organization.userRating = true;
        this.organization.ratingCount = this.organization.ratingCount + 1;
      },
      removeStar() {
        this.organization.userRating = false;
        this.organization.ratingCount = this.organization.ratingCount - 1;
      },
    },
  };
